import { render } from "./TracesSubview.vue?vue&type=template&id=637a8503&scoped=true"
import script from "./TracesSubview.vue?vue&type=script&lang=js"
export * from "./TracesSubview.vue?vue&type=script&lang=js"

import "./TracesSubview.vue?vue&type=style&index=0&id=637a8503&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637a8503"]])

export default __exports__